import React, { FunctionComponent } from "react";
import { IShelf } from "../../../hooks/shelves";
import { ShelfSegmentRepresentation } from "../ShelfSegmentRepresentation";
import styles from "./styles.module.scss";
import { IShelfSegment, IShelfSegmentAlbum } from "../../../hooks/shelfSegments";
import { IShelving } from "../../../hooks/shelvings";

export const ShelfRepresentation: FunctionComponent<IShelfRepresentationProps> = ({
  shelving,
  shelvings,
  setShelvings,
  shelf,
  selectedShelfSegment,
  selectedAlbumIds,
  isLoading,
  setIsLoading,
  onShelfSegmentAlbumSelected,
  onRemoveAlbumFromShelfSegment,
  onShelfSegmentFetched,
  shelvingIndex,
  shelfIndex,
  zoom,
  canRemove,
  onModifyShelf,
  onModifyShelfSegment,
  onModifyShelving,
  onFocus,
  onAssignAlbumsToShelfSegmentByFilter,
  isMinimalist
}) => {
  const shelfSegmentRepresentation = (segment: IShelfSegment, index: number) => (
    <ShelfSegmentRepresentation
      key={segment.uuid}
      shelving={shelving}
      shelvings={shelvings}
      setShelvings={setShelvings}
      shelf={shelf}
      shelfSegmentId={segment.uuid}
      overrideShelfSegment={segment}
      selectedAlbumIds={selectedAlbumIds}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      onShelfSegmentAlbumSelected={onShelfSegmentAlbumSelected}
      onRemoveAlbumFromShelfSegment={(album, segmentIndex, albumIndex) =>
        onRemoveAlbumFromShelfSegment(album, shelfIndex, segmentIndex, albumIndex)
      }
      onShelfSegmentFetched={(shelfSegment, segmentIndex) =>
        onShelfSegmentFetched(shelfSegment, shelfIndex, segmentIndex)
      }
      shelvingIndex={shelvingIndex}
      shelfIndex={shelfIndex}
      segmentIndex={index}
      canRemove={canRemove}
      onModifyShelfSegment={onModifyShelfSegment}
      onModifyShelving={onModifyShelving}
      onModifyShelf={onModifyShelf}
      onFocus={onFocus}
      onAssignAlbumsToShelfSegmentByFilter={onAssignAlbumsToShelfSegmentByFilter}
      showOptions={!isMinimalist}
    />
  );
  return (
    <div
      key={shelf.uuid}
      className={styles.shelf}
      style={{
        width: shelving.orientation == "horizontal" ? "100%" : `${540 * zoom}px`,
        height: shelving.orientation == "horizontal" ? `${540 * zoom}px` : "100%",
        flexDirection: shelving.orientation == "horizontal" ? "row" : "column"
      }}
    >
      {selectedShelfSegment
        ? shelfSegmentRepresentation(
            selectedShelfSegment,
            shelf.segments.map(segment => segment.uuid).indexOf(selectedShelfSegment.uuid)
          )
        : shelf.segments
            ?.sort((a, b) => a.order - b.order)
            .map((segment, index) => shelfSegmentRepresentation(segment, index))}
    </div>
  );
};

export interface IShelfRepresentationProps {
  shelving: IShelving;
  shelvings: IShelving[];
  setShelvings: (shelvings: IShelving[]) => void;
  shelf: IShelf;
  selectedShelfSegment?: IShelfSegment;
  selectedAlbumIds: string[];
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  onShelfSegmentAlbumSelected: (shelfSegmentAlbum: IShelfSegmentAlbum) => void;
  onRemoveAlbumFromShelfSegment: (
    shelfSegmentAlbum: IShelfSegmentAlbum,
    shelfIndex: number,
    shelfSegmentIndex: number,
    albumIndex: number
  ) => void;
  onShelfSegmentFetched: (
    shelfSegment: IShelfSegment,
    shelfIndex: number,
    shelfSegmentIndex: number
  ) => void;
  shelvingIndex: number;
  shelfIndex: number;
  zoom: number;
  canRemove: boolean;
  onModifyShelving: (shelving: IShelving) => void;
  onModifyShelf: (shelf: IShelf) => void;
  onModifyShelfSegment: (shelf: IShelf, segment: IShelfSegment) => void;
  onFocus: (shelf: IShelf, segment: IShelfSegment) => void;
  onAssignAlbumsToShelfSegmentByFilter: (shelfSegment: IShelfSegment) => void;
  isMinimalist: boolean;
}
